var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevron = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "8px",
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chevron") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "API---option-1",
    transform: "translate(-228.000000, -77.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(225.000000, 17.000000)",
    id: "Chevron/Updown"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 9.000000) scale(1, -1) translate(-9.000000, -9.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.61001993,5.37979914 L9.00019882,9.59827444 L13.3883103,5.38181551 C13.5651914,5.20673362 13.8190595,5.20673362 13.9938732,5.37979914 L14.8696995,6.24686718 C15.0434335,6.41886384 15.0434335,6.66685692 14.8696995,6.83885359 L9.36609514,12.163573 C9.18969193,12.3381942 8.93582376,12.3381942 8.7610101,12.1651287 L3.12753876,6.83579607 C2.95696414,6.66685692 2.95696414,6.41886384 3.13069814,6.24686718 L4.00652445,5.37979914 C4.1813381,5.20673362 4.43520628,5.20673362 4.61001993,5.37979914 Z",
    id: "Path"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevron);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Chevron.405717b9254191c22b38cb8e0b25e0d1.svg";